import { Grid } from "@material-ui/core";
import { RootState } from "config/store";
import { useQuery } from "react-query";
import { useSelector } from "react-redux";
import { getProductionByGroupCode, getProductionById } from "shared/network/production.api";
import ItemCard from "./ItemCard";

const Page2ItemSettings = ({ groupCode, id }: { groupCode?: string; id?: string | null }) => {
  const tenant = useSelector((state: RootState) => state.authentication?.selectedRelTenant);

  const getProductionByGroupCodeQuery = useQuery(
    ["getProductionByGroupCodeQuery", groupCode, tenant.id],
    async () => {
      if (groupCode) {
        const { data } = await getProductionByGroupCode(groupCode, tenant.id);
        return data.items;
      }
      return Promise.reject();
    },
    { enabled: !!groupCode },
  );
  const productionList = getProductionByGroupCodeQuery?.data;

  const getProductionByIdQuery = useQuery(
    ["getProductionByGroupCodeQuery", groupCode, tenant.id],
    async () => {
      if (id) {
        const { data } = await getProductionById(Number(id), tenant.id);
        return data.item;
      }
      return Promise.reject();
    },
    { enabled: !!id },
  );

  return (
    <Grid container spacing={2}>
      {groupCode
        ? productionList?.map((production, index) => (
            <Grid key={index} item xs={12} sm={12}>
              <ItemCard
                key={index}
                production={production}
                refetch={getProductionByGroupCodeQuery.refetch}
              />
            </Grid>
          ))
        : !!getProductionByIdQuery?.data && (
            <Grid item xs={12} sm={12}>
              <ItemCard
                production={getProductionByIdQuery?.data}
                refetch={getProductionByIdQuery.refetch}
              />
            </Grid>
          )}
    </Grid>
  );
};

export default Page2ItemSettings;
